import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoSquare } from '@fortawesome/pro-solid-svg-icons/faInfoSquare';
import { faTimesOctagon } from '@fortawesome/pro-solid-svg-icons/faTimesOctagon';
import classNames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import { Icon } from '../Icon';
import './style.scss';
import { IAlertProps } from './types';

export class Alert extends Component<PropsWithChildren<IAlertProps>, {}> {
  public render() {
    const { ...rest } = this.props;
    const alertClasses = classNames('alert', 'hl-alert', {
      'hl-alert-danger': this.props.danger,
      'hl-alert-info': this.props.info,
      'hl-alert-success': this.props.success,
      'hl-alert-warning': this.props.warning,
    });

    const icon =
      (this.props.success && faCheckCircle) ||
      (this.props.info && faInfoSquare) ||
      (this.props.danger && faTimesOctagon) ||
      (this.props.warning && faExclamationTriangle) ||
      faCheckCircle;
    return (
      <div className={alertClasses} role={'alert'}>
        <div className={'hl-alert-icon'}>
          <Icon icon={icon} />
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default Alert;
